import { FacetModel } from "./../models/facet";
import { PanelTabsView } from "./../../desktop/views/panel-tabs";
import { TabFactory } from "./../../desktop/helpers/tab-factory";
import { MaterialFilterGroupView } from "./material-filter-group";
import { MaterialFilterPanelView } from "./material-filter-panel";
import {backboneViewProperties} from "../../decorators/backbone-properties";

const template = require<string>("./material-filter.html");

@backboneViewProperties({
    template,
    className: "material-type",
    tagName: "div",
})
export class MaterialFilterView extends Marionette.LayoutView<FacetModel> {

    public childrenRegion: Marionette.Region;

    constructor(options?) {
        super(options);
        this.setupModelListeners();
    }

    public regions(): any {
        const regions = {
            childrenRegion: ".children-region"
        };

        return regions;
    }

    public onShow() {
        this.tickedChanged();
        if (this.model.SubFacets) {
            this.childrenRegion.show(new MaterialFilterGroupView({collection: this.model.SubFacets}));
        }
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events[`click .js-material[data-material="${this.model.Name}"]`] = (e) => this.materialLinkClick(e);

        return events;
    }

    public setupModelListeners() {
        this.listenTo(this.model, "change:Ticked", this.tickedChanged);
        this.listenTo(this.model, "change:Enabled", this.enabledChanged);
        this.listenTo(this.model, "change:PartiallyTicked", this.tickedChanged);
        this.listenTo(this.model.SubFacets, "change:Ticked", this.childTickedChanged);

    }

    public tickedChanged() {
        this.$(`input[data-material="${this.model.Name}"]`).prop({
            checked: this.model.Ticked,
            indeterminate: this.model.PartiallyTicked
        });
    }

    public enabledChanged(model, property) {
        this.$(".wrapper").toggleClass("disabled", !property);
        this.$(".js-material").toggleClass("disabled", !property);
    }

    public childTickedChanged() {
        let allSame = true;
        const first = this.model.SubFacets.first();
        this.model.SubFacets.forEach((sf) => {
            if (sf.Ticked !== first.Ticked) {
                allSame = false;
            }
        });

        if (allSame) {
            this.model.Ticked = first.Ticked;
            this.model.PartiallyTicked = false;
        } else {
            this.model.Ticked = true;
            this.model.PartiallyTicked = true;
        }
    }

    private materialLinkClick(e: JQueryEventObject) {
        const $target = $(e.currentTarget);
        if ($target.hasClass("disabled")) {
            return false;
        }

        if (this.model.PartiallyTicked) {
            this.model.Ticked = true;
            this.model.PartiallyTicked = false;
        } else {
            this.model.Ticked = !this.model.Ticked;

        }

        const newVal = this.model.Ticked; // need to store this, as this.model.ticked will change within the loop - this is because it changes the child, which triggers ChildTickedChanged()

        if (this.model.SubFacets) { // Get children to agree with parent
            this.model.SubFacets.forEach((sf) => {
                sf.Ticked = newVal;
            });
        }

        this.model.searchModel.filterChangedReRunSearch();

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/material-filter.ts